import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Features from "../components/Features";
import { useTranslation } from 'react-i18next';

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div
      className="custom-arrow custom-next"
      onClick={onClick}
      style={{ right: 30 }}
    >
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="20" fill="rgba(0,0,0,0.3)" />
        <path d="M10 8l4 4-4 4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div
      className="custom-arrow custom-prev"
      onClick={onClick}
      style={{ left: 30 }}
    >
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="20" fill="rgba(0,0,0,0.3)" />
        <path d="M14 8l-4 4 4 4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  );
};

const Home = () => {
  const { t } = useTranslation();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const slides = [
    {
      image: '/images/marble_1.jpg',
      title: t('hero.slide1.title'),
      subtitle: t('hero.slide1.subtitle')
    },
    {
      image: '/images/marble_2.jpg',
      title: t('hero.slide2.title'),
      subtitle: t('hero.slide2.subtitle')
    },
    {
      image: '/images/marble_3.jpg',
      title: t('hero.slide3.title'),
      subtitle: t('hero.slide3.subtitle')
    }
  ];

  return (
    <>
      <div style={{ width: "100vw", height: "100vh", position: "relative", overflow: "hidden" }}>
        <Slider {...settings}>
          {slides.map((slide, idx) => (
            <div key={idx} className="hero-slide">
              <div 
                className="hero-background"
                style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${slide.image})` }}
              >
                <div className="hero-content">
                  <h1>{slide.title}</h1>
                  <p>{slide.subtitle}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
        <style>{`
          .custom-arrow {
            position: absolute;
            top: 50%;
            z-index: 2;
            transform: translateY(-50%);
            cursor: pointer;
            background: none;
            border: none;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .custom-next { right: 30px; }
          .custom-prev { left: 30px; }
          .custom-arrow svg circle {
            transition: fill 0.2s;
          }
          .custom-arrow:hover svg circle {
            fill: rgba(0,0,0,0.5);
          }
          .slick-slider, .slick-list, .slick-track, .slick-slide > div {
            height: 100vh !important;
          }
        `}</style>
      </div>
      <Features />
    </>
  );
};

export default Home; 